import { render, staticRenderFns } from "./TasksToolbar.vue?vue&type=template&id=1c8121f0&"
import script from "./TasksToolbar.vue?vue&type=script&lang=js&"
export * from "./TasksToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports